import React from 'react';
import { Link } from 'react-router-dom';
const PageNotFound = () => {
    return (React.createElement("div", { style: { color: 'grey' } },
        React.createElement("h1", null, "OOPS! How did you land here?"),
        React.createElement("p", null,
            "Let's get you back. Click",
            ' ',
            React.createElement(Link, { style: { textDecoration: 'none' }, to: "/" }, "HERE"),
            ' ',
            "to go to Home Page")));
};
export { PageNotFound };
